import React, { useEffect, useState } from 'react';
import * as R from 'ramda';

import { EtablissementsTableHeader } from './header';
import { EtablissementsTableRow } from './row';
import { EtablissementsTableNav } from './nav';

import Emptylustration from './../../../../../assets/images/svg/057-contract-1.svg';
import { LoadingState } from '../../../../../_common/loadingState';
import * as Loadings from '../../../../../constants/loadings/backoffice/partners';


export const EtablissementsTable = ({ etablissements, users, setSelectedEtablissement, pageSearch, setPageSearch, routerQuery, partnerState }) => {

    const [filters, setFilters] = useState({
        order: {
            column: "name",
            asc: true
        },
        search: "",
        status: "all",
    });

    const [displayableElements, setDisplayableElements] = useState(undefined);

    useEffect(() => {
        let temp = etablissements;
        // if (!R.isEmpty(filters.search)) {
        //     temp = temp.filter(d => d.siret.search(filters.search) > -1 || d.name.search(filters.search) > -1);
        // }
        // if (filters.status === "active") {
        //     temp = temp.filter(d => d.isEnabled);
        // }
        // if (filters.status === "inactive") {
        //     temp = temp.filter(d => !d.isEnabled);
        // }


        // setDisplayableElements(filters.order.asc ? R.sort(R.ascend(R.prop(filters.order.column)), temp) : R.sort(R.descend(R.prop(filters.order.column)), temp));
        setDisplayableElements(temp);

    }, [filters, etablissements]);

    // if (partnerState.isLoading.includes(Loadings.FETCHING_ETABLISSEMENTS)) {
    // 	return <LoadingState />;
    // }

    return (
        <div className="container-fluid h-inherit flex-column">
            <EtablissementsTableNav filters={filters} setFilters={setFilters} pageSearch={pageSearch} setPageSearch={setPageSearch} routerQuery={routerQuery} partnerState={partnerState} />
            {
                partnerState.isLoading.includes(Loadings.FETCHING_ETABLISSEMENTS) ?
                    <LoadingState />
                    :
                    <section className="block">
                        <h1 className="sr-only visually-hidden">Établissement</h1>

                        {R.isNil(displayableElements) || displayableElements <= 0 ?
                            <section className="block fs-3 text-center m-auto py-5">
                                <img className="img-fluid img-contain container-paper mx-auto mb-4" src={Emptylustration} alt="Assist@" />
                                <div className="block text-center container-thin mx-auto">
                                    <h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas d'établissements.</h1>
                                    <p className="o-80 mb-0">Veuillez ajouter un nouvel établissement.</p>
                                </div>
                            </section>
                            :
                            <React.Fragment>
                                <EtablissementsTableHeader filters={filters} setFilters={setFilters} routerQuery={routerQuery} partnerState={partnerState} />
                                {displayableElements.map((etablissement) => {
                                    return (
                                        <EtablissementsTableRow key={etablissement.id} etablissement={etablissement} setSelectedEtablissement={setSelectedEtablissement} numberOfUsers={etablissement.numberOfDossiers} />

                                    );
                                })}
                            </React.Fragment>
                        }
                    </section>
            }
        </div>
    );

};